import cardPriceTemplate from '@templates/components/organisms/card-house-pricing.html.njk';
import type { HousePrice } from '../store/HousePrices';

export class PriceRenderer {
    render(
        pricingElement: HTMLElement,
        price: HousePrice,
        translations: Record<string, string>
    ): void {
        const cta = pricingElement.querySelector('.card__content__cta');
        pricingElement.innerHTML = cardPriceTemplate.render({ house: price, translations });

        if (cta !== null) {
            pricingElement.appendChild(cta);
        }
    }
}

export default new PriceRenderer();
